import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import {
  requestGetNoticePopup,
  requestUpdateReadForNoticePopup,
  setDisplayingAppPopup,
  setNoticePopups,
  requestApprovedOrRejectedRank
} from '@redux/actions';
import {
  DATING_NOTICE_POPUP,
  ResponseStatus,
  FEMALE_USER_RANK,
  UserGender,
  LINE_LINK,
  BACHELOR_POINT_PAGE_URL
} from '@constants/constant';
import TermsOfUsePopup from './TermsOfUsePopup';
import ConsentRequiredPopup from './ConsentRequiredPopup';
import StartBachelorPointPopup from './StartBachelorPoint';
import RankPromotedSuccessPopUp from './RankPromotedSuccess';
import IncreaseInPointsAwardedPopup from './IncreaseInPointsAwarded';
import FirstTimeFemaleRankPopUp from './FirstTimeFemaleRank';
import BlackUserConciergePopup from './BlackUserConcierge';
import BlackUserWelcomePopup from './BlackUserWelcome';
import { fetchUserRank } from '@api/userRank';
import { fetchBachelorPointIsEnabled } from '@api/bachelorPoint';

const NoticePopupManager = ({
  loggedIn,
  location,
  history,
  requestGetNoticePopup,
  requestUpdateReadForNoticePopup,
  setDisplayingAppPopup,
  requestApprovedOrRejectedRank,
  userGlobalInfo,
  setNoticePopups,
  noticePopups
}) => {
  const [showTermsOfUsePopup, setShowTermsOfUsePopup] = useState(false);
  const [showConsentRequiredPopup, setShowConsentRequiredPopup] =
    useState(false);
  const [showStartBachelorPointPopup, setShowStartBachelorPointPopup] =
    useState(false);
  const [showRankPromotedSuccessPopup, setShowRankPromotedSuccessPopup] =
    useState(false);
  const [
    showIncreaseInPointsAwardedPopup,
    setShowIncreaseInPointsAwardedPopup
  ] = useState(false);
  const [showFirstTimeFemaleRankPopup, setShowFirstTimeFemaleRankPopup] =
    useState(false);
  const [showBlackUserConciergePopup, setShowBlackUserConciergePopup] =
    useState(false);
  const [showBlackUserWelcomePopup, setShowBlackUserWelcomePopup] =
    useState(false);
  const [userCurrentRank, setUserCurrentRank] = useState(null);
  const [userCurrentRankText, setUserCurrentRankText] = useState(null);
  const [isBachelorPointEnabled, setIsBachelorPointEnabled] = useState(false);
  const [isApprovedPromoteRank, setIsApprovedPromoteRank] = useState(false);
  const [dataLoaded, setDataLoaded] = useState({
    rank: false,
    pointEnabled: false,
    noticePopup: false
  });

  const isMale =
    userGlobalInfo &&
    userGlobalInfo.data &&
    userGlobalInfo.data.user_gender === UserGender.MALE;

  const fetchNoticePopup = () => {
    const notShowLoading = location.pathname === '/subscription-paused-request';
    requestGetNoticePopup({ notShowLoading }, (response) => {
      if (response.status === ResponseStatus.SUCCESS) {
        const fetchedNoticePopups = response.data.data.notice_popup;
        setNoticePopups(fetchedNoticePopups);
        setDataLoaded((prev) => ({ ...prev, noticePopup: true }));
      }
    });
  };

  const getUserRank = () => {
    fetchUserRank().then((response) => {
      if (response.status === ResponseStatus.SUCCESS) {
        const rank =
          response.data && response.data.data && response.data.data.rank;
        if (rank && rank.current_rank) {
          setUserCurrentRank(rank.current_rank.type);
          setUserCurrentRankText(rank.current_rank.text);
        }
        if (rank) {
          setIsApprovedPromoteRank(rank.is_approved_promote_rank);
        }
        setDataLoaded((prev) => ({ ...prev, rank: true }));
      }
    });
  };

  const getBachelorPointEnabled = () => {
    fetchBachelorPointIsEnabled().then((response) => {
      if (response.status === ResponseStatus.SUCCESS) {
        setIsBachelorPointEnabled(response.data.data.is_enabled);
        setDataLoaded((prev) => ({ ...prev, pointEnabled: true }));
      }
    });
  };

  useEffect(() => {
    if (loggedIn) {
      getUserRank();
      fetchNoticePopup();
      getBachelorPointEnabled();
    }
  }, [loggedIn]);

  // データがすべて取得されたら、ポップアップ表示処理に移る
  useEffect(() => {
    if (dataLoaded.rank && dataLoaded.pointEnabled && dataLoaded.noticePopup) {
      // 利用規約popup最優先
      if (noticePopups.includes(DATING_NOTICE_POPUP.terms_of_use)) {
        setDisplayingAppPopup(true);
        setShowTermsOfUsePopup(true);
        return;
      }
      // 初回ランク昇格
      if (noticePopups.includes(DATING_NOTICE_POPUP.show_female_rank)) {
        setDisplayingAppPopup(true);
        setShowFirstTimeFemaleRankPopup(true);
        return;
      }
      // ランク昇格
      if (isApprovedPromoteRank) {
        setDisplayingAppPopup(true);
        setShowRankPromotedSuccessPopup(true);
        return;
      }
      // ブラックユーザーウェルカム
      if (noticePopups.includes(DATING_NOTICE_POPUP.black_user_welcome)) {
        setDisplayingAppPopup(true);
        setShowBlackUserWelcomePopup(true);
        return;
      }
      // ブラックプラン昇格
      if (noticePopups.includes(DATING_NOTICE_POPUP.black_user_concierge)) {
        setDisplayingAppPopup(true);
        setShowBlackUserConciergePopup(true);
        return;
      }
      // バチェラーポイント開始
      if (noticePopups.includes(DATING_NOTICE_POPUP.bachelor_point_activated)) {
        setDisplayingAppPopup(true);
        setShowStartBachelorPointPopup(true);
        return;
      }
    }
  }, [dataLoaded, userCurrentRank, isApprovedPromoteRank, noticePopups]);

  // 表示するpopupがない場合は、setDisplayingAppPopupをfalseにする
  useEffect(() => {
    const popupsToCheck = [
      DATING_NOTICE_POPUP.terms_of_use,
      DATING_NOTICE_POPUP.bachelor_point_activated,
      DATING_NOTICE_POPUP.show_female_rank,
      DATING_NOTICE_POPUP.black_user_concierge,
      DATING_NOTICE_POPUP.black_user_welcome
    ];

    if (
      !isApprovedPromoteRank &&
      !noticePopups.some((popup) => popupsToCheck.includes(popup))
    ) {
      setDisplayingAppPopup(false);
    }
  }, [noticePopups, setDisplayingAppPopup]);

  const onPositiveClickTermsOfUse = () => {
    const params = {
      notice_popup: DATING_NOTICE_POPUP.terms_of_use
    };
    requestUpdateReadForNoticePopup(params, () => {});

    const updatedPopups = noticePopups.filter(
      (item) => item !== DATING_NOTICE_POPUP.terms_of_use
    );
    setShowTermsOfUsePopup(false);
    setNoticePopups(updatedPopups);
  };

  const onCloseTermsOfUsePopup = () => {
    setShowTermsOfUsePopup(false);
    setShowConsentRequiredPopup(true);
  };

  const onPositiveClickConsentRequired = () => {
    setShowTermsOfUsePopup(true);
    setShowConsentRequiredPopup(false);
  };

  const handleRankPromotedSuccessPositiveClick = () => {
    requestApprovedOrRejectedRank();
    const isDiamondOrBlack =
      userCurrentRank === FEMALE_USER_RANK.DIAMOND ||
      userCurrentRank === FEMALE_USER_RANK.BLACK;

    // ポイント開始待機中のユーザーにポイント増加のお知らせが出ないようにしておく
    if (
      isBachelorPointEnabled &&
      isDiamondOrBlack &&
      !noticePopups.includes(DATING_NOTICE_POPUP.bachelor_point_activated)
    ) {
      setShowRankPromotedSuccessPopup(false);
      setShowIncreaseInPointsAwardedPopup(true);
      setIsApprovedPromoteRank(false);
      return;
    }

    setShowRankPromotedSuccessPopup(false);
    setIsApprovedPromoteRank(false);
  };

  const handleIncreaseInPointsAwardedPopupPositiveClick = () => {
    setShowIncreaseInPointsAwardedPopup(false);
    setDisplayingAppPopup(false);
    window.open(BACHELOR_POINT_PAGE_URL, '_blank');
    // 簡易対応終了後はこっちを使う
    // history.push('/bachelor-point')
  };

  const handleIncreaseInPointsAwardedPopupClose = () => {
    setShowIncreaseInPointsAwardedPopup(false);
    setDisplayingAppPopup(false);
  };

  const onPositiveClickStartBachelorPoint = () => {
    const params = {
      notice_popup: DATING_NOTICE_POPUP.bachelor_point_activated
    };

    const updatedPopups = noticePopups.filter(
      (item) => item !== DATING_NOTICE_POPUP.bachelor_point_activated
    );
    setNoticePopups(updatedPopups);
    setShowStartBachelorPointPopup(false);

    // サーバー側の更新が完了してからページ遷移
    requestUpdateReadForNoticePopup(params, () => {
      // 詳細ページに遷移
      history.push('/about-bachelor-point');
    });
  };

  const handleFirstTimeFemaleRankPopupClose = () => {
    const params = {
      notice_popup: DATING_NOTICE_POPUP.show_female_rank
    };
    requestUpdateReadForNoticePopup(params, () => {});

    const updatedPopups = noticePopups.filter(
      (item) => item !== DATING_NOTICE_POPUP.show_female_rank
    );
    setShowFirstTimeFemaleRankPopup(false);
    setNoticePopups(updatedPopups);
  };

  const handleBlackUserConciergePopupClick = () => {
    const LINELink = isMale ? LINE_LINK.MALE_LINK : LINE_LINK.FEMALE_LINK;
    window.open(LINELink, '_blank');

    const params = {
      notice_popup: DATING_NOTICE_POPUP.black_user_concierge
    };
    requestUpdateReadForNoticePopup(params, () => {});

    const updatedPopups = noticePopups.filter(
      (item) => item !== DATING_NOTICE_POPUP.black_user_concierge
    );
    setNoticePopups(updatedPopups);
    setShowBlackUserConciergePopup(false);
  };

  const handleBlackUserWelcomePopupClick = () => {
    const params = {
      notice_popup: DATING_NOTICE_POPUP.black_user_welcome
    };
    requestUpdateReadForNoticePopup(params, () => {});

    const updatedPopups = noticePopups.filter(
      (item) => item !== DATING_NOTICE_POPUP.black_user_welcome
    );
    setNoticePopups(updatedPopups);
    setShowBlackUserWelcomePopup(false);
  };

  return (
    <>
      <TermsOfUsePopup
        visible={showTermsOfUsePopup}
        onPositiveClick={onPositiveClickTermsOfUse}
        onNegativeClick={onCloseTermsOfUsePopup}
      />
      <ConsentRequiredPopup
        visible={showConsentRequiredPopup}
        onPositiveClick={onPositiveClickConsentRequired}
      />
      <RankPromotedSuccessPopUp
        getUserCurrentRank={userCurrentRank}
        getUserCurrentRankText={userCurrentRankText}
        isVisible={showRankPromotedSuccessPopup}
        onPositiveClicked={handleRankPromotedSuccessPositiveClick}
      />
      <IncreaseInPointsAwardedPopup
        isVisible={showIncreaseInPointsAwardedPopup}
        onClose={handleIncreaseInPointsAwardedPopupClose}
        onPositiveClicked={handleIncreaseInPointsAwardedPopupPositiveClick}
        userCurrentRank={userCurrentRank}
        userCurrentRankText={userCurrentRankText}
      />
      <StartBachelorPointPopup
        isVisible={showStartBachelorPointPopup}
        userCurrentRank={userCurrentRank}
        onPositiveClicked={onPositiveClickStartBachelorPoint}
      />
      <FirstTimeFemaleRankPopUp
        isVisible={showFirstTimeFemaleRankPopup}
        getUserCurrentRank={userCurrentRank}
        getUserCurrentRankText={userCurrentRankText}
        onNegativeClicked={handleFirstTimeFemaleRankPopupClose}
      />
      <BlackUserConciergePopup
        isVisible={showBlackUserConciergePopup}
        isMale={isMale}
        onPositiveClicked={handleBlackUserConciergePopupClick}
      />
      <BlackUserWelcomePopup
        isVisible={showBlackUserWelcomePopup}
        onPositiveClicked={handleBlackUserWelcomePopupClick}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  loggedIn: state.auth.loggedIn,
  userGlobalInfo: state.userGlobalInfo,
  noticePopups: state.app.noticePopups
});

const mapDispatchToProps = {
  requestGetNoticePopup,
  requestUpdateReadForNoticePopup,
  setDisplayingAppPopup,
  setNoticePopups,
  requestApprovedOrRejectedRank
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(NoticePopupManager);
